module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper fixgraybgpl"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoSqueeze),
      expression: "!videoSqueeze"
    }],
    staticClass: "video-player-background",
    class: {
      'animated zoomOutLeft': _vm.videoCompleted
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "video-player",
    on: {
      "mouseleave": function($event) {
        _vm.addRightHoverWidthClass ? _vm.resetClass(true) : _vm.resetClass(false)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideLeftVideoIcons),
      expression: "!hideLeftVideoIcons"
    }],
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.getUserNewPlaylistObject) ? _c('div', {
    staticClass: "reset-video-width",
    class: {
      'enjoy-hover': _vm.addEnjoyHoverClass
    }
  }, [_c('jwplaylist', {
    attrs: {
      "data": _vm.getUserNewPlaylistObject,
      "on-playlistitem": _vm.videoChangedInPlaylist()
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.playlistVideos) ? _c('div', {
    staticClass: "playlistholderdiv"
  }, [_c('h4', [_vm._v(_vm._s(_vm.playlistVideos.title))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.videoIndex) + " of " + _vm._s(_vm.playlistVideos.userPlaylistVideos.length) + ")")]), _vm._v(" "), _c('div', _vm._l((_vm.getUserNewPlaylistObject), function(item) {
    return (_vm.getUserNewPlaylistObject && _vm.getItemChangeInPlaylist) ? _c('div', [_c('div', {
      staticClass: "playlistentrydiv",
      class: {
        'playing': item.videoCode === _vm.getItemChangeInPlaylist.item.videoCode
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-pressed": (item.videoCode === _vm.getItemChangeInPlaylist.item.videoCode) ? 'true' : 'false',
        "aria-label": item.title,
        "src": item.image,
        "alt": item.title,
        "title": item.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-pressed": (item.videoCode === _vm.getItemChangeInPlaylist.item.videoCode) ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.playVideoInPlylist(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])]) : _vm._e()
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.getExpert[0].expertId + '/' + _vm.getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert && _vm.getExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.getExpert && _vm.getExpert[0].areasofexpertise) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-3"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: ([_vm.viewTranscript ? {
      color: _vm.$a11yTextColor(this.getCorpButtonColor) + ' !important',
      backgroundColor: this.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    } : {
      color: _vm.getCorpButtonColor + ' !important',
      backgroundColor: '#FFFFFF !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important',
      outline: 'none !important'
    }]),
    on: {
      "click": _vm.toggleViewTranscript
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewTranscript),
      expression: "!viewTranscript"
    }]
  }, [_vm._v("View Transcript")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }]
  }, [_vm._v("Hide Transcript")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-9"
  }, [(_vm.getCurrentVideoTranscript) ? _c('div', {
    staticClass: "side-content",
    style: ({
      'border-left-color': this.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewTranscript),
      expression: "viewTranscript"
    }],
    staticClass: "boxes",
    class: {
      'animated fadeIn': _vm.viewTranscript, 'animated fadeOut': !_vm.viewTranscript
    }
  }, [_c('pre', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentVideoTranscript.vtt_file)
    }
  }, [_vm._v("\n                                    ")])])])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.recommendationList), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "jw-img",
      attrs: {
        "aria-label": reccentVideo.title,
        "src": reccentVideo.image,
        "title": reccentVideo.title,
        "alt": reccentVideo.title
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(reccentVideo.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                    ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.redirectToRelatedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RELATED VIDEOS")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d9ff14b", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d9ff14b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/PlaylistVideoPlayer.vue